module.exports = __webpack_public_path__ + "img/B0.c2b0920f.png";